import type { ColumnMetadata } from '../grid/types';

const RICH_TEXT_EDITORS = new Set(['tinymceeditor', 'richtexteditor']);

const normalizeEditor = (value: unknown): string =>
  String(value ?? '')
    .trim()
    .toLowerCase();

/** Detect rich-text / HTML fields from metadata `editor`. */
export const isRichTextFieldMetadata = (metadata: ColumnMetadata): boolean =>
  RICH_TEXT_EDITORS.has(normalizeEditor(metadata.editor));

/** Detect file-reference fields (e.g. Resume) from metadata `dataType`/`dvt`. */
export const isFileFieldMetadata = (metadata: ColumnMetadata): boolean =>
  metadata?.dataType === 'file' || metadata?.dvt === 'file';

/** Rich text and multiline fields always span the full section grid row. */
export const shouldFieldSpanFullWidth = (metadata: ColumnMetadata): boolean =>
  isRichTextFieldMetadata(metadata) ||
  metadata?.editor === 'textarea' ||
  metadata.dataType === 'zReactNode';
